import React, { Fragment, useContext, useEffect } from 'react';
import CheckBoxMenu from './CheckBoxMenu';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { StyledMenuSpan } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';
import { MM, PCPP, PCPF } from '../Context/constants';

type MedsCppPlanMenuProps = {
  note: mumms.progressNotebyEntity | mumms.progressNote | null;
  type: mumms.PNEntityTypeShortname;
  saveInitialNote: boolean | undefined;
};

const MedsCppPlanMenu = ({
  note,
  type,
  saveInitialNote,
}: MedsCppPlanMenuProps) => {
  const {
    patientCarePlanProblems,
    carePlanFrequencies,
    medications,
  } = useContext(ProgressNotesContext);

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    // componentDidMount
    // returned function will be called on component unmount
    return () => {
      // componentDidUnMount
      // ? the idea was to refresh API progress note on unmount if updatedNote
      // updatedNote is NULL inside as did not get the update.
    };
  }, []);

  const getMedsMenu = () =>
    medications && medications.length ? (
      medications.map((med: mumms.Medication) => (
        <CheckBoxMenu
          key={med.id}
          note={note as mumms.progressNotebyEntity}
          text={med.drugdescription}
          entitykey={med.externalid}
          entitytypeshortname={MM}
          med={med}
          saveInitialNote={saveInitialNote}
        />
      ))
    ) : (
      <StyledMenuSpan>{defaults.noMeds}</StyledMenuSpan>
    );

  const getPCPPMenu = () =>
    patientCarePlanProblems && patientCarePlanProblems.length ? (
      patientCarePlanProblems.map((cpp: mumms.patientCarePlanProblem) => (
        <CheckBoxMenu
          note={note as mumms.progressNotebyEntity}
          carePlan={cpp}
          text={cpp.careplanproblemname}
          entitykey={cpp.id}
          entitytypeshortname={PCPP}
          key={cpp.id}
          saveInitialNote={saveInitialNote}
        />
      ))
    ) : (
      <StyledMenuSpan>{defaults.noCP}</StyledMenuSpan>
    );
  // console.log('carePlanFrequencies', carePlanFrequencies);
  const getPCPFMenu = () =>
    carePlanFrequencies && carePlanFrequencies.length ? (
      carePlanFrequencies.map((cppf: mumms.patientCarePlanProblemFrequency) => (
        <CheckBoxMenu
          note={note as mumms.progressNotebyEntity}
          carePlanFrequency={cppf}
          text={`${cppf.discipline}`}
          entitykey={`${cppf.patientNumber}-${cppf.discipline}`}
          entitytypeshortname={PCPF}
          key={cppf.id}
          saveInitialNote={saveInitialNote}
        />
      ))
    ) : (
      <StyledMenuSpan>{defaults.noCPF}</StyledMenuSpan>
    );

  const getMenuContent = () =>
    note ? getMenuType() : <div>{defaults.noNote}</div>;

  const getMenuType = () => {
    switch (type) {
      case MM:
        return getMedsMenu();
      case PCPF:
        return getPCPFMenu();
      case PCPP:
        return getPCPPMenu();
      default:
        return <div>{defaults.noNote}</div>;
    }
  };

  return <Fragment>{getMenuContent()}</Fragment>;
};

export default MedsCppPlanMenu;
